import { editorUndo } from "../MonacoEditorHelper";
import { previewAudioPlay, previewCode, registerAsset } from "../../features/assets/asset-utils";

export function AssetLibEntryAudio(props: { data : any, tab : any }) {
  const previewAudio = () => {
    previewCode(props.data, props.tab);
    previewAudioPlay(props.data);
  }

  const undoPreview = () => {
    editorUndo();
  }

  const insertAudioCode = () => {
    previewCode(props.data, props.tab);
    registerAsset(props.data);
  }

  return (
    <div className='gallery_product col-lg-1 col-md-1 col-sm-1 col-xs-1' onMouseEnter={previewAudio} onMouseLeave={undoPreview} onClick={insertAudioCode}>
        <img className='img-responsive box-wh' src="/assets/img/sound.png" alt={props.data.name} loading="lazy" />
      <p className='text-center'>{props.data.name}</p>
      <audio id={`audio-${props.data.name}`} >
        <source src={props.data.file} />
      </audio>
    </div>
    );
}
